import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface UserState {
  id: string;
  avatar: string;
  email: string;
  fullName: string;
  roles: string;
  userName: string | null | undefined;
}

export interface SetUserPayloadAction {
  id: string;
  avatar: string;
  email: string;
  fullName: string;
  roles: string;
  userName: string | null | undefined;
}

const initialState = {
  id: "",
  avatar: "",
  email: "",
  fullName: "",
  roles: "",
  userName: null,
} as UserState;

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<SetUserPayloadAction>) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export const userSelector = (state: any) => state.user as UserState;

export const { setUser } = userSlice.actions;
export default userSlice.reducer;
